import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PaginationRounded from "./paginacao";
import FormataTitulo from "../utils/formataTitulo";
import "../paginas/funcionario/Emprestimo.css";
import Loading from "../utils/Loading";
import { CircularProgress } from "@mui/material";

const StyledTableCell = styled(TableCell)(() => ({
  "&.MuiTableCell-head": {
    fontSize: 20,
    padding: "18px",
  },
  "&.MuiTableCell-body": {
    fontSize: 18,
    padding: "18px",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--cor-roxoEscuroTabela)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--cor-branco)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const widthTitulo = "48%";
const width2Coluna = "45%";
const widthGeral = "32%";
const widthAcervo = "22%";
const widthAcoes = "10%";

export default function Tabela({
  dados,
  colunas,
  estiloTabela,
  qtdPaginas,
  clickPaginacao,
  acoes,
  carregandoPagina,
  isPaginado = true,
  naoTemAcoes
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [linhaSelecionada, setLinhaSelecionada] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setLinhaSelecionada(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLinhaSelecionada(null);
  };

  function widthColuna(coluna) {
    let columnWidth;
    switch (coluna) {
      case "titulo":
        columnWidth = widthTitulo;
        break;
      case "autor":
        columnWidth = width2Coluna;
        break;
      case "telefone":
      case "aluno":
      case "email":
      case "emprestimo":
      case "status":
      case "devolucao":
      case "num_emprestimo":
      case "genero":
      case "pontuacao":
      case "localizacao":
      case "turma":
        columnWidth = widthGeral;
        break;
      case "acervo":
      case "disponibilidade":
        columnWidth = widthAcervo;
        break;
      case "acoes":
        columnWidth = widthAcoes;
        break;
      default:
        // eslint-disable-next-line
        columnWidth = "auto";
    }
    return columnWidth;
  }

  function truncarTexto(texto, limite) {
    if (!texto) return "";
    return texto.length > limite ? texto.slice(0, limite) + "..." : texto;
  }

  return (
    <>
      <TableContainer component={Paper} sx={estiloTabela}>
        <Table
          sx={{ minWidth: 700, tableLayout: "fixed" }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {colunas.map((c, index) => {

                return (
                  <StyledTableCell
                    key={index}
                    align="left"
                    style={{
                      width: widthColuna(c),
                      // position: "sticky",
                      top: 0,
                      backgroundColor: "var(--cor-branco)",
                      zIndex: 1,
                    }}
                  >
                    {FormataTitulo(c)}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {carregandoPagina ? (
              <TableRow>
                <TableCell
                  colSpan={100}
                  align="center"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "50%",
                    width: "583%",
                    border: 'none'
                  }}
                >
                  <CircularProgress sx={{ color: "var(--cor-roxoEscuro)" }} />
                </TableCell>
              </TableRow>
            ) : (
              dados &&
              dados.map((row, rowIndex) => (
                <StyledTableRow key={rowIndex}>
                  {colunas.map((coluna, colIndex) => {
                    const valor = Array.isArray(row[coluna])
                      ? row[coluna].join(", ")
                      : row[coluna];

                    if (coluna === "status") {
                      return (
                        <StyledTableCell align="left" key={colIndex}>
                          <div className="status_container">
                            <div
                              className={`${
                                row[coluna] === "EM_DIA" ||
                                row[coluna] === "Em dia"
                                  ? "status_emDia"
                                  : row[coluna] === "Sem livros"
                                  ? "status_vazio"
                                  : "status_emAtraso"
                              }`}
                            ></div>
                            <span title={valor}>
                              {truncarTexto(row[coluna], 10)}
                            </span>
                          </div>
                        </StyledTableCell>
                      );
                    }
                    if (coluna === "localizacao") {
                      return (
                        <StyledTableCell
                          align="left"
                          key={colIndex}
                          title={valor}
                        >
                          <p title={valor}>{truncarTexto(row[coluna], 14)}</p>
                        </StyledTableCell>
                      );
                    }

                    if (coluna === "disponibilidade") {
                      return (
                        <StyledTableCell
                          align="left"
                          key={colIndex}
                          title={valor}
                        >
                          <p style={{ paddingLeft: 25 }} title={valor}>
                            {truncarTexto(row[coluna], 10)}
                          </p>
                        </StyledTableCell>
                      );
                    }
                    if (coluna === "num_emprestimo") {
                      return (
                        <StyledTableCell
                          align="left"
                          key={colIndex}
                          title={valor}
                        >
                          <p style={{ paddingLeft: 50 }} title={valor}>
                            {truncarTexto(row[coluna], 10)}
                          </p>
                        </StyledTableCell>
                      );
                    }
                    if (coluna === "autor") {
                      return (
                        <StyledTableCell
                          align="left"
                          key={colIndex}
                          title={valor}
                        >
                          <p style={{ marginRight: 5 }}>
                            {truncarTexto(row[coluna], 20)}
                          </p>
                        </StyledTableCell>
                      );
                    }

                    if (coluna !== "acoes") {
                      return (
                        <StyledTableCell
                          align="left"
                          key={colIndex}
                          title={valor}
                        >
                          <p style={{ marginRight: 5 }}>
                            {truncarTexto(row[coluna], 22)}
                          </p>
                        </StyledTableCell>
                      );
                    }
                    return null;
                  })}
                  <StyledTableCell align="left">
                    <IconButton onClick={(e) => handleClick(e, row)}>
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      sx={{
                        "& .MuiPaper-root": {
                          backgroundColor: "var(--cor-roxoClaro)",
                          boxShadow: "none",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        },
                      }}
                    >
                      {acoes && !naoTemAcoes &&
                        acoes.map((acao, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => {
                              acao.func(linhaSelecionada);
                              handleClose();
                            }}
                          >
                            <img
                              src={acao.icon}
                              alt={acao.texto}
                              style={{ marginRight: 10 }}
                            />
                            {acao.texto}
                          </MenuItem>
                        ))}
                    </Menu>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isPaginado && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PaginationRounded
            qtdPaginas={qtdPaginas}
            clickPaginacao={clickPaginacao}
          />
        </div>
      )}
    </>
  );
}
